module.exports = __webpack_public_path__ + "img/icon-ship-active.5dfdc95.png";